import { WifiOff } from 'lucide-react';
import { SystemMessageLayout } from '../ui/SystemMessageLayout';

interface NetworkOfflineProps {
  onRetry?: () => void;
  onDismiss?: () => void;
}

export function NetworkOffline({ onRetry, onDismiss }: NetworkOfflineProps) {
  return (
    <SystemMessageLayout
      icon={<WifiOff className="w-12 h-12 text-danger-500" strokeWidth={1.5} />}
      title="No Connection"
      description="The application cannot reach the server. Your device may be offline or the service is temporarily unavailable. Your data is safe — once the connection is restored, you can continue where you left off."
      action={{
        label: 'Try Again',
        onClick: onRetry ?? (() => window.location.reload()),
      }}
      secondaryAction={onDismiss ? {
        label: 'Continue Anyway',
        onClick: onDismiss,
        variant: 'ghost',
      } : undefined}
    />
  );
}
